import { jobArchitectureChatSlotRenderers } from '~/feature/job-architecture-v2';

import type { ChatSlotRenderers } from '../chat';

// Composition root for feature-provided chat composer slot content. Register a
// feature's renderers here instead of importing feature code inside chat.
export const appChatSlotRenderers: readonly ChatSlotRenderers[] = [jobArchitectureChatSlotRenderers];
